import dayjs from 'dayjs';
import React from 'react';

import { formatPayPeriod } from 'features/pending-timesheets/models/pending-timesheets.model';
import SmartComponent from 'utils/smart-component';

import '../styles/pay-cycle-separator.scss';
import '../styles/pay-cycle-separator.mobile.scss';

import { Col, Row } from 'reactstrap';

export interface IPayCycleSeparatorProps {
    payPeriodStart: string;
    payPeriodEnd: string;
}

export interface IPayCycleSeparatorState {
    verbiage: string;
}

const useInitialState = (props: IPayCycleSeparatorProps): IPayCycleSeparatorState => {
    const payPeriodStart = formatPayPeriod(dayjs(props.payPeriodStart));
    const payPeriodEnd = formatPayPeriod(dayjs(props.payPeriodEnd));
    const verbiage = `The following timesheet(s) were submitted late by traveler(s) for work week ${payPeriodStart} - ${payPeriodEnd}`;

    return {
        verbiage,
    };
};

const renderDesktop = ({ verbiage }: IPayCycleSeparatorState): JSX.Element => (
    <tr className={'pay-cycle-separator'}>
        <td colSpan={10}>{verbiage}</td>
    </tr>
);

const renderMobile = ({ verbiage }: IPayCycleSeparatorState): JSX.Element => (
    <Row className={'pay-cycle-separator pay-cycle-separator-mobile'}>
        <Col>{verbiage}</Col>
    </Row>
);

export { renderDesktop as PayCycleSeparatorDesktop, renderMobile as PayCycleSeparatorMobile };
export default SmartComponent<IPayCycleSeparatorProps, IPayCycleSeparatorState>(
    useInitialState,
    renderDesktop,
    renderMobile,
);
